export default __webpack_public_path__ + "static/media/Agency_client_collaboration_with_LinkedIn_tool.5bdcdcbf.svg";